import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const CachetShape = {
  url: Yup.string().label("URL").url().required(),
  token: Yup.string().label("API Token").max(20).required(),
  component: Yup.string().label("Component ID").optional(),
  metric: Yup.string().label("Metric ID").optional(),
};

export interface CachetInput {
  url: string;
  token: string;
  component?: string;
  metric?: string;
}

yupResolver<CachetInput>(Yup.object().shape(CachetShape));
